import Swiper from "swiper";
import {
    Navigation,
    Pagination,
    Autoplay,
    EffectFade,
    Thumbs,
} from "swiper/modules";

new Swiper(".voiceSwiper", {
    slidesPerView: "auto",
});

new Swiper(".pickupSwiper", {
    slidesPerView: "auto",
    centeredSlides: true,
    // loop: true,
    spaceBetween: 15,
    speed: 1000,
    autoplay: {
        delay: 5000,
        waitForTransition: true,
    },
    modules: [Autoplay, Navigation, Pagination],
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    initialSlide: 1,
    breakpoints: {
        1025: {
            spaceBetween: 30,
            centeredSlides: false,
        },
    },
});

const phiCfg = {
    slidesPerView: "auto",
    loop: true,
    speed: 2000,
    modules: [Autoplay, EffectFade],
    autoplay: {
        delay: 4000,
    },
    effect: "fade",
    fadeEffect: {
        crossFade: true,
    },
};

new Swiper(".phi1Swiper", phiCfg);

new Swiper(".phi2Swiper", phiCfg);

const pgSwiper = new Swiper(".pgSwiper", {
    slidesPerView: "auto",
    loopAdditionalSlides: 5,
    loop: true,
    spaceBetween: 15,
    speed: 1000,
    autoplay: {
        delay: 5000,
        waitForTransition: true,
    },
    modules: [Autoplay, Pagination],
    pagination: {
        el: ".swiper-pagination",
        // clickable: true,
        // レンダーをカスタマイズして$pgDataの数だけ表示
        renderBullet: function (index, className) {
            // $pgDataの要素数を超えたらnullを返して表示しない
            if (index >= this.el.dataset.slides) return "";
            return `<span class="${className}"></span>`;
        },
    },
    breakpoints: {
        1025: {
            centeredSlides: true,
            spaceBetween: 30,
        },
    },
    // クリック時の処理
    on: {
        paginationClick: (swiper, e, index) => {
            // 現在のインデックスと目標のインデックスを取得
            const currentIndex = swiper.realIndex;
            const totalSlides = Number(swiper.el.dataset.slides);

            // 最短経路の計算
            let distance = index - currentIndex;

            // 逆方向の距離を計算
            if (distance > totalSlides / 2) {
                distance -= totalSlides;
            } else if (distance < -totalSlides / 2) {
                distance += totalSlides;
            }

            // 現在の実際のスライド位置を取得
            const currentSlide = swiper.activeIndex;

            // 目標のスライド位置を計算
            const targetSlide = currentSlide + distance;

            console.log({ currentIndex, distance, currentSlide, targetSlide });

            // アニメーションありで移動
            swiper.slideTo(targetSlide, 300);
        },
        // スライド変更時のイベント
        slideChange: (swiper) => {
            // console.log(swiper.realIndex);
            const totalSlides = Number(swiper.el.dataset.slides);
            // 実際のインデックスを$pgDataの範囲内に収める
            const currentIndex = swiper.realIndex % totalSlides;

            // 一旦全てのページネーションからアクティブクラスを削除
            document
                .querySelectorAll(".swiper-pagination-bullet")
                .forEach((bullet) =>
                    bullet.classList.remove("swiper-pagination-bullet-active")
                );

            // 現在のスライドに対応するページネーションにアクティブクラスを追加
            document
                .querySelector(
                    `.swiper-pagination-bullet:nth-child(${currentIndex + 1})`
                )
                ?.classList.add("swiper-pagination-bullet-active");
        },
    },
});

if (pgSwiper.slides.length) {
    // ページネーションのクリックイベントも同様に
    pgSwiper.el
        .querySelectorAll(".swiper-pagination-bullet")
        .forEach((bullet, index) => {
            bullet.addEventListener("click", () => {
                // 現在のインデックスと目標のインデックスを取得
                const currentIndex = pgSwiper.realIndex;
                const totalSlides = Number(pgSwiper.el.dataset.slides);

                // 最短経路の計算
                let distance = index - currentIndex;

                // 逆方向の距離を計算
                if (distance > totalSlides / 2) {
                    distance -= totalSlides;
                } else if (distance < -totalSlides / 2) {
                    distance += totalSlides;
                }

                // 現在の実際のスライド位置を取得
                const currentSlide = pgSwiper.activeIndex;

                // 目標のスライド位置を計算
                const targetSlide = currentSlide + distance;

                // アニメーションありで移動
                pgSwiper.slideTo(targetSlide);
            });
        });
}

const rts = document.querySelectorAll(".roomThumbSwiper");
const rs = document.querySelectorAll(".roomSwiper");

rts.forEach((rt, index) => {
    const roomThumbSwiper = new Swiper(rt, {
        slidesPerView: "auto",
    });

    const roomSwiper = new Swiper(rs[index], {
        slidesPerView: "auto",
        watchSlidesProgress: true,
        modules: [Thumbs],
        thumbs: {
            swiper: roomThumbSwiper,
        },
    });
});
